import * as React from "react";
import { RouteComponentProps } from "react-router";
import {
  updateMonitoringUrlHistory,
  updateInsightsUrlHistory,
} from "../../../../redux/modules/urlHistory/actionCreators";
import { SEARCH_KEY } from "../constants";
import { updateQueryString } from "..";

export const useQueryState = (
  history: RouteComponentProps["history"],
  updateUrlHistory:
    | typeof updateMonitoringUrlHistory
    | typeof updateInsightsUrlHistory
) => {
  const setQuery = React.useCallback(
    function setQuery(query: string) {
      updateQueryString(query, history, SEARCH_KEY);
      updateUrlHistory(history.location, history.action);
    },
    [history]
  );

  return {
    setQuery,
  };
};
